import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  /* Progression rate 0 to 1*/
  @Input() progressRate = 0;
  @Input() progressStartAt = 0;
  @Input() color = 'var(--app-brand-context-500)';

  get progressStartAtPercent() {
    return Math.max(Math.min(Math.round(this.progressStartAt * 100), 100), 0);
  }

  get progressPercent() {
    return (
      Math.max(Math.min(Math.round(this.progressRate * 100), 100), 0) -
      this.progressStartAtPercent
    );
  }
}
